import { ChevronLeft } from 'lucide-react';
import Button from '../ui/Button';
import SearchField from './SearchField';

/** Search route chrome: back button + shared {@link SearchField}. */
export default function SearchChrome({
  searchInput,
  setSearchInput,
  searchInputRef,
  onBack,
  onClear,
  placeholder = 'Search',
  backLabel = 'Back',
  autoFocus = true,
}) {
  return (
    <div className="flex items-center gap-2">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onBack}
        aria-label={backLabel}
        className="!h-auto shrink-0 !p-2 -ml-2 text-gray-600 dark:text-dark-text"
      >
        <ChevronLeft className="w-6 h-6" aria-hidden />
      </Button>
      <SearchField
        ref={searchInputRef}
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        placeholder={placeholder}
        onClear={onClear}
        autoFocus={autoFocus}
        className="flex-1 min-w-0"
      />
    </div>
  );
}
